import { toast as sonnerToast } from 'sonner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const toast = sonnerToast as typeof sonnerToast & { warn: typeof sonnerToast['message'] };

toast.warn = (message, data) =>
	toast(message, {
		...data,
		className: 'sonner-toast-warn',
		icon: <FontAwesomeIcon icon={['fas', 'triangle-exclamation']} />,
	});
